module.exports = "https://cdn01.riselinkedu.com/assets/lottie/img_1.e3ab3f54.png";